import BaseProjectApi from "../BaseProjectApi";

export default abstract class BaseProjectIdApi extends BaseProjectApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/${params["projectId"]}`;
	}
}
